// extracted by mini-css-extract-plugin
export default {"disclaimerButtons":"ExternalLink_disclaimerButtons__1ynIp"};